import EmptyState from '../EmptyState'

const ResultNoSteps = () =>
  <EmptyState title='No steps found' />

export default ResultNoSteps
